import { DoohScreenCoordinate } from "@/types/DoohScreen";
import { createSlice } from "@reduxjs/toolkit";

interface coordinatesState {
	coordinates: DoohScreenCoordinate[] | [];
	isLoading: boolean;
}

const initialState: coordinatesState = {
	coordinates: [],
	isLoading: false,
};

const doohDataSlice = createSlice({
	name: "doohData",
	initialState,
	reducers: {
		setCoordinatesData(state, action) {
			state.coordinates = action.payload;
		},
		showLoading(state, action) {
			state.isLoading = action.payload;
		},
	},
});

export const { setCoordinatesData, showLoading } = doohDataSlice.actions;

export default doohDataSlice.reducer;
